import React from "react";
import VerticalImageList from "shared/components/VerticalImageList";

export default function ProductAlternatives({ variants }) {
  if (variants && variants.length === 0) {
    return null;
  }

  const items = variants.map(variant => {
    let image = "";
    if (variant.images.length > 0) {
      image = variant.images[0].thumbnail;
    }

    const url = variant.id;
    return { url, image };
  });

  return (
    <div>
      <h4>Weitere Sorten:</h4>
      <VerticalImageList items={items} />
    </div>
  );
}
